// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__3kj97","icon":"CartButton_icon__KA2Vb","badge":"CartButton_badge__YQOu4","bump":"CartButton_bump__v5Iet"};